export const vert = /*glsl*/ `
precision mediump float;

uniform mat4 projectionMatrix;
uniform mat4 modelViewMatrix;
uniform float uTime;
uniform float uParticlesEffectIntensity;

attribute vec3 position;
attribute vec2 uv;

varying vec2 vUv;
varying float isDust;

#define PI 3.141592

void main() {
  vUv = uv * 2. - vec2(.5, 0.);
  float t = uTime * .00001 + uParticlesEffectIntensity * .4;
  float seed = position.x;


  float theta = position.y + t;
  float radius = .5 + seed * .5;

  float theta2 = (sin(position.y + t) + 1.) * PI + t;


  vec3 pos = vec3(
    cos(theta) * radius,
    sin(seed * PI * 40. + t) + abs(1. - sin(position.z)),
    sin(theta) * radius
  ) * 2.5;

  pos += vec3(
    cos(pos.x + t * 5. + theta2) * (pos.y * 3. + sin(seed * 36. + t) * 10.) * .2,
    pos.z + pos.y,
    sin(pos.x + t * 5. + theta2) * (pos.y * 3. + sin(seed * 36. + t) * 10.) * .2
  ) * .5;

  pos.y = abs(pos.y);

  mat4 cModelViewMatrix = modelViewMatrix;

  vec4 mvPosition = cModelViewMatrix * vec4(pos, 1.);
  pos.xy += (1. / -mvPosition.z) * (50. + isDust * 500.) * (uv * (.01 + uParticlesEffectIntensity * .4) - (.01 + uParticlesEffectIntensity * .4) * vec2(.5, .25));

  mvPosition = cModelViewMatrix * vec4(pos, 1.);
  
  gl_Position = projectionMatrix * mvPosition;
  
  isDust = min(1., smoothstep(1., 4., length(pos.xz)) + smoothstep(2., 0., gl_Position.z));
  // gl_PointSize = (1. / -mvPosition.z) * (50. + isDust * 500.);
}`;
